/**
 * Versión de build de la aplicación — fuente única de verdad.
 *
 * Este archivo se edita con `npm run version:bump`, no a mano. En cada build,
 * `prebuild` copia estos valores a `public/version.json`, que es lo que el
 * navegador consulta para saber si hay una versión más nueva en el servidor.
 * Al generarse los dos del mismo lugar, no pueden quedar desincronizados.
 *
 * ¿Por qué un número propio y no el hash de los bundles?
 * ------------------------------------------------------
 * Create React App ya le pone un hash al nombre de cada bundle, así que un
 * archivo nuevo nunca se sirve desde la caché de uno viejo. Lo que *no*
 * resuelve es el `index.html`: ese conserva la misma URL siempre, y si el
 * navegador lo tiene cacheado sigue apuntando a los bundles anteriores. La app
 * queda vieja entera sin que nada parezca roto.
 *
 * Un número de versión legible da además algo que el hash no: poder decirle al
 * usuario «tenés la v12 y hay una v13», y saber qué versión está corriendo
 * cuando alguien reporta un problema.
 */

export const APP_BUILD = {
  version: 47,
  builtAt: '2026-10-05T17:28:49.445Z',
};

export default APP_BUILD;
